import React from "react";
 const BookingProcess = () => {
  return (
    <>
      <div
        id="rs-latest-news-style7"
        className="rs-latest-news-style7 sec-spacer"
      >
        <div className="container">
          <div className="row rs-latest-list">
            <h2 className="title text-center pb-50 md-pb-30  mt-2 ">
              📚 Teacher Booking Process on{" "}
              <strong style={{ color: "#f7b205" }}>TopFaculty.co.in</strong>
            </h2>
            <div className="col-lg-5 mb-pt-50  ">
              {/* Additional Info */}

              <img
                src="assetsfront/images/add1.png"
                alt="FAQ"
                className="mt-1 zoom-hover p-1"
              />

              <ul className="space-y-4 text-lg text-gray-700 list-disc pl-6">
                <h4 className="text-3xl font-bold text-indigo-900 mt-3 text-center">
                  ℹ️ Additional Benefits
                </h4>
                <li>
                  <strong>Flexible Scheduling:</strong> Learn anytime, anywhere
                  with custom class timings.
                </li>
                <li>
                  <strong> Free Trial:</strong> Explore the platform with a
                  no-commitment trial period.
                </li>
                <li>
                  <strong>Verified Teachers:</strong> All educators are manually
                  and AI-verified for your peace of mind.
                </li>
                <li>
                  <strong>Need Help?</strong> Contact support at{" "}
                  <a
                    href="mailto:topfauclty01@gmail.com"
                    className="text-blue-600 hover:underline"
                  >
                    topfauclty01@gmail.com
                  </a>{" "}
                  or call 011-45623333 / +91 9990963333.
                </li>
              </ul>
              <img
                src="assetsfront/images/add2.png"
                alt="FAQ"
                className="mt-1 zoom-hover p-1"
              />
            </div>

            <div className="col-lg-7" style={{ marginTop: "40px" }}>
              <div className="mb-14">
                <h3 className="text-2xl font-semibold text-gray-800">
                  <img src="assetsfront/images/1.png" style={{ width: "30px", height: "30px" }}/>&nbsp;

                  Student Registration  
                </h3>
                <p className="mt-2 text-gray-600 text-lg">
                  Begin your learning journey by registering for free on the
                  <a
                    href="https://topfaculty.co.in/"
                    className="text-blue-600 hover:underline"
                  >
                    TopFaculty Student Portal
                  </a>
                  . Signing up is simple and gives you access to a vast network
                  of experienced teachers across India.
                </p>
              </div>
              {/* Step 2 */}
              <div className="mb-14">
                <h3 className="text-2xl font-semibold text-gray-800">
                  <img src="assetsfront/images/2.png" style={{ width: "30px", height: "30px" }}/>&nbsp; Search for Teachers
                </h3>
                <p className="mt-2 text-gray-600 text-lg">
                  Use the smart search filters to find qualified teachers based
                  on subject, location, availability, and more. Choose the ones
                  that best match your learning preferences and goals.
                </p>
              </div>
              {/* Step 3 */}
              <div className="mb-14">
                <h3 className="text-2xl font-semibold text-gray-800">
                 <img src="assetsfront/images/3.png" style={{ width: "30px", height: "30px" }}/>&nbsp; Post Your Learning Requirements
                </h3>
                <p className="mt-2 text-gray-600 text-lg">
                  Not sure who to choose? Post your specific learning
                  requirements and let the right teachers come to you. The
                  system will match you with top-rated, verified educators.
                </p>
              </div>
              {/* Step 4 */}
              <div className="mb-14">
                <h3 className="text-2xl font-semibold text-gray-800">
                 <img src="assetsfront/images/4.png" style={{ width: "30px", height: "30px" }}/>&nbsp; Connect with Teachers
                </h3>
                <p className="mt-2 text-gray-600 text-lg">
                  Once matched, browse teacher profiles, read reviews, chat
                  directly, and schedule classes at your convenience. Build
                  trust before you commit.
                </p>
              </div>
              {/* Step 5 */}
              <div className="mb-14">
                <h3 className="text-2xl font-semibold text-gray-800">
                  <img src="assetsfront/images/5.png" style={{ width: "30px", height: "30px" }}/>&nbsp; Book a Demo Class
                </h3>
                <p className="mt-2 text-gray-600 text-lg">
                  Try before you buy! Book a free demo class to understand the
                  teacher’s style and assess compatibility. It's a risk-free way
                  to ensure you’ve found the right mentor.
                </p>
              </div>
              {/* Step 6 */}
              <div className="mb-14">
                <h3 className="text-2xl font-semibold text-gray-800">
                 <img src="assetsfront/images/6.png" style={{ width: "30px", height: "30px" }}/>&nbsp; Confirm and Start Learning
                </h3>
                <p className="mt-2 text-gray-600 text-lg">
                  Like the demo? Confirm your booking and start your
                  personalized learning experience. Enjoy interactive sessions
                  designed to help you succeed.
                </p>
              </div>
              {/* Step 7 */}
              <div className="mb-14">
                <h3 className="text-2xl font-semibold text-gray-800">
                <img src="assetsfront/images/7.png" style={{ width: "30px", height: "30px" }}/>&nbsp; Study Material
                </h3>
                <p className="mt-2 text-gray-600 text-lg">
                  Study materials, it's important to offer high-quality,
                  educational resources that help students learn and succeed.To
                  score good marks used study materials.
                </p>
              </div>
            </div>

            {/* <div className="col-lg-2"></div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingProcess;
